module.exports = __webpack_public_path__ + "img/successful1.7260110a.png";